module.exports = __webpack_public_path__ + "img/44_icon.6c90925f.png";